import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StaticApiService } from '../../features/static-api/staticApi.service';
import { ActivatedRoute } from '@angular/router';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';

@Component({
  selector: 'app-static-page-list',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
  ],
  templateUrl: './static-page-view.component.html',
  styleUrl: './static-page-view.component.scss',
})
export class StaticPageViewComponent {
  pageId: any;
  staticPageData: any = null;
  public languages: any[] = [];

  constructor(
    private staticContentService: StaticApiService,
    private route: ActivatedRoute,
    private tagsService: TagsLanguageService
  ) {}

  ngOnInit() {
    this.getLanguages();
    this.route.paramMap.subscribe((params) => {
      this.pageId = params.get('id');
      if (this.pageId) {
        this.getStaticPageContent(this.pageId);
      }
    });
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getLanguageName(langId: number): string {
    const lang = this.languages.find((l) => l.id === langId);
    return lang ? lang.name : `Lang ID: ${langId}`;
  }

  getStaticPageContent(id: any) {
    this.staticContentService.getStaticContentById(id).subscribe({
      next: (res) => {
        this.staticPageData = res.data;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
